import bindKey from '../bindnode/_bindkey.js';
import select from '../select.js';
import forEach from '../_helpers/foreach.js';
import { matches } from '../_dom/index.js';
var FIELDS = 'input, textarea, output, progress, select';
// a selector, HTML, a node or an array-like of nodes; the first node
function one(selector) {
  if (!selector) return null;
  if (typeof selector === 'string') {
    if (!/</.test(selector)) return document.querySelector(selector);
    var container = document.createElement('div');
    container.innerHTML = selector;
    return container.firstElementChild;
  }
  if (!selector.dispatchEvent && typeof selector.length === 'number') {
    return selector[0];
  }
  return selector;
}
// a form's fields: those inside it (form.elements misses <input type="image">) and those tied to it by the form attribute
function getFields(form) {
  var inside = form.querySelectorAll(FIELDS);
  if (form.nodeName !== 'FORM') {
    return inside;
  }
  var fields = Array.prototype.filter.call(inside, function (field) {
    return !field.form || field.form === form;
  });
  forEach(form.elements, function (field) {
    if (matches(field, FIELDS) && fields.indexOf(field) === -1) {
      fields.push(field);
    }
  });
  // document order
  return fields.sort(function (a, b) {
    return a.compareDocumentPosition(b) & form.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
  });
}
// binds the named fields of a form (or any container) to the properties of their names; returns the form
function parseForm(object, selector, callback, eventOptions) {
  if (!object || typeof object !== 'object' && typeof object !== 'function') {
    throw new TypeError('parseForm should accept an object or a function as the first argument');
  }
  var form = /:sandbox|:bound/.test(selector) ? select(object, selector) : one(selector);
  if (!form) {
    return null;
  }
  var fields = getFields(form);
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    // a <progress> has no name property, only the attribute
    var name = field.getAttribute('name');
    if (name) {
      bindKey(object, name, field, undefined, eventOptions);
      if (callback) {
        callback(name, field);
      }
    }
  }
  return form;
}
export { parseForm };